export default __webpack_public_path__ + "static/user4-8f2662cb3c23b1f68e3f8dd15cb7b814.jpeg";